import { links, SettingsNames, Link } from './settings-links-map'

export const useSettingsLinks = () => {
  const getSettingsLinks = () => {
    return links
  }

  const getSettingByKey = (key: SettingsNames) => {
    const link: Link | undefined = links.get(key)
    if (!link) return
    if (!link.subLinks) {
      return link
    }

    return link
  }

  return {
    getSettingsLinks,
    getSettingByKey,
  }
}
